import React, { useState, useEffect } from "react";
import { Minus, Plus, Heart } from "lucide-react";

export default function ProductCard({ product, onAddToCartClick, liked: initialLiked, initialQuantity }) {

  const [quantity, setQuantity] = useState(initialQuantity || 0);
  const [liked, setLiked] = useState(initialLiked || false);

  useEffect(() => {
    setLiked(initialLiked);
  }, [initialLiked]);

  // Increase Qty
  const increaseQty = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
    onAddToCartClick(product, 1);
  };

  // Decrease Qty
  const decreaseQty = () => {
    if (quantity > 0) {
      const newQty = quantity - 1;
      setQuantity(newQty);
      onAddToCartClick(product, -1);
    }
  };

  // Manual Quantity Input
  const handleQtyChange = (e) => {

    let value = e.target.value.replace(/[^0-9]/g, "");

    value = value === "" ? 0 : parseInt(value);

    const diff = value - quantity;

    setQuantity(value);

    if (diff !== 0) {
      onAddToCartClick(product, diff);
    }
  };

  // Like Toggle
  const toggleLike = async () => {

    const vid = localStorage.getItem("vid");

    if (!vid) {
      alert("Please login first");
      return;
    }

    try {
      await fetch(
        `${window._config?.apiBaseUrl}/LikedItem?databaseKey=${window._config?.databaseKey}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Vid: parseInt(vid),
            ItemId: product.id
          })
        }
      );

      setLiked(!liked);

    } catch (err) {
      console.error("Like error:", err);
    }
  };

  return (

    <div className="relative bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden flex flex-col">

      {/* Like Button */}
      <button
        onClick={toggleLike}
        className={`absolute top-3 right-3 p-2 rounded-full shadow-md transition-colors
        ${liked ? "bg-red-100 text-red-600" : "bg-white text-gray-400 hover:bg-gray-100"}`}
      >
        <Heart size={20} fill={liked ? "red" : "none"} strokeWidth={2} />
      </button>

      {/* Product Image */}
      <div className="h-48 bg-gray-100 flex items-center justify-center">
        <img
          src={product.image}
          alt={product.name}
          className="h-full object-contain"
        />
      </div>

      {/* Product Info */}
      <div className="p-4 flex flex-col flex-grow">

        <h3 className="font-semibold text-gray-800 text-lg line-clamp-2">
          {product.name}
        </h3>

        {/* Quantity Controls */}
        <div className="mt-auto pt-4 flex justify-center">

          <div className="flex items-center bg-white border border-gray-200 rounded-full shadow-sm overflow-hidden">

            {/* Minus Button */}
            <button
              onClick={decreaseQty}
              disabled={quantity === 0}
              className={`px-3 py-2 transition
              ${quantity > 0
                ? "bg-red-50 text-red-600 hover:bg-red-100"
                : "bg-gray-100 text-gray-400 cursor-not-allowed"}`}
            >
              <Minus size={16} />
            </button>

            {/* Manual Input */}
            <input
              type="text"
              value={quantity}
              onChange={handleQtyChange}
              className="w-12 text-center outline-none font-semibold"
            />

            {/* Plus Button */}
            <button
              onClick={increaseQty}
              className="px-3 py-2 bg-teal-50 text-teal-700 hover:bg-teal-100 transition"
            >
              <Plus size={16} />
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}
